<template>
  <div class="flex flex-wrap gap-6 lg:gap-16 bg-white p-12 rounded-2xl">
    <div class="w-32 h-32 rounded-full flex items-center justify-center  bg-zinc-100 p-6">
      <img
        :src="caseStudy.metaimage"
        class="w-full h-auto"
      >
    </div>

    <div class="flex flex-col flex-1">
      <h2
        class="text-2xl pb-3"
      >
        <CaseStudyTitle :title="caseStudy.title" />
      </h2>
      <p>
        {{ caseStudy.brief }}
      </p>
      <div class="flex justify-end gap-3 items-center">
        <!-- <p class="mt-6 p-2 bg-zinc-200  px-3 uppercase  self-start rounded-lg">
          {{ caseStudy.client }}
        </p> -->

        <ButtonGeneral
          :to="`${caseStudy._path}`"
          theme="white"
          class="mt-2 self-end"
          text="Read More"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ caseStudy: CaseStudy }>()
</script>

<style scoped>

</style>
